module.exports = "<div #stepContainer></div>\n<div class=\"pagination\">\n    <div class=\"dot-container\" *ngFor=\"let step of constants.steps; let index = index;\">\n        <div class=\"dot\" [ngClass]=\"{'active': index <= currentStepIndex}\"></div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/registration/registration.component.html
// module id = 536
// module chunks = 0